import Past from "../past";
export default function Pshx() {
  return <Past past="surgical" />;
}
